<template>
  <div class="container">
    <h1>Registrieren</h1>
    <div class="login-box">
      <label for="username"><b>Benutzername</b></label>
      <input id="username" type="text" placeholder="Benutzername">

      <label for="password"><b>Passwort</b></label>
      <input id="password" type="password" placeholder="Passwort">

      <label for="confirm-password"><b>Passwort bestätigen</b></label>
      <input id="confirm-password"
             type="password"
             placeholder="Passwort bestätigen">

      <div class="login-button primary">
        Registrieren
      </div>

      <span class="register-text">
        Zurück zur
        <router-link to="Login">Anmeldung</router-link>.
      </span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Register',
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
}

.login-box {
  display: flex;
  flex-direction: column;
  width: 400px;
  padding: 20px;
  border: 1px solid #ddd;
  margin: 40px auto 0;
  align-self: auto;
}

.login-box-title {
  font-weight: bold;
  font-size: 18pt;
  margin-bottom: 20px;
  text-align: center;
}

input[type=text], input[type=password] {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: "TheSans UHH", sans-serif;
}

.login-button {
  height: 45px;
  border: 1px solid #ddd;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  margin: 10px 4px 4px 4px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  user-select: none;
}

.login-button:hover {
  background-color: #026cb2;
}

.login-button:focus {
  box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .5);
}

.primary {
  background-color: #027bcb;
  color: white;
}

.register-text {
  margin-top: 10px;
}
</style>
